import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M17.2 7a6 7 0 1 0 0 10","key":"svg-0"}],["path",{"d":"M13 10h-8m0 4h8","key":"svg-1"}]]

const IconCurrencyEuro = createReactComponent('outline', 'currency-euro', 'CurrencyEuro', __iconNode);

export default IconCurrencyEuro;